import { render, staticRenderFns } from "./PsychologyTable.vue?vue&type=template&id=075f29dc&"
import script from "./PsychologyTable.vue?vue&type=script&lang=js&"
export * from "./PsychologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports